import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { Bucket } from '../../types';
import { BucketService } from '../../services/bucket.service';
import { UiIconComponent } from '../../ui/icon/icon.component';

/**
 * Standalone flat Transfers card (LCL-66) — shown at the bottom of the budget
 * list when the "Show transfers" filter is on. Transfers is a system-managed
 * concept (money moved between accounts, not spending), so this card sits
 * outside the category groups and drops the elevated-card + budget-progress
 * chrome. Clicking it opens the transfers drawer view for the month.
 */
@Component({
  selector: 'app-transfers-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './transfers-card.component.html',
  imports: [CurrencyPipe, UiIconComponent],
})
export class TransfersCardComponent {
  private readonly bucketService = inject(BucketService);

  readonly bucket = input.required<Bucket>();
  /** Number of transfer transactions this month. */
  readonly transactionCount = input(0);
  readonly opened = output<Bucket>();

  /** All-time fund balance — the same figure the transfers drawer's BALANCE shows. */
  readonly balance = computed(() => this.bucketService.getBalance(this.bucket()));

  open(): void {
    this.opened.emit(this.bucket());
  }
}
